import { useEffect } from 'react'

const useGetDocumentTitlePrice = () => {
  useEffect(() => {
    document.title = 'ToonSwap DEX | Ethereum'
    // document.title = `ArcherSwap - $${Number(cakePriceUsd).toLocaleString(undefined, {
    //   minimumFractionDigits: 3,
    //   maximumFractionDigits: 3,
    // })}`
  })
}
export default useGetDocumentTitlePrice
